<div class="popupWrapper">
    <div class="info">
        <img src="../../../assets/img/logo-small.png" alt="Logo de URG">
        <h2>{{title}}</h2>
        <p>{{body}}</p>
    </div>
    <div class="btns">
        <button (click)="closePopup(false)">{{btns[0]}}</button>
        <button (click)="closePopup(true)">{{btns[1]}}</button>
    </div>
</div>